import React, {ReactElement} from 'react';
import {Snackbar} from '@mui/material';
import {Alert, AlertTitle} from '@customink/pigment-react';
import {AppError, clearError} from '../../slices/appSlice';
import {useAppSelector, useAppDispatch} from '../../hooks';
import NotFound from '../../components/NotFound';

type AppErrorRendererPropType = {
  children: React.ReactNode;
};

const errorSwitch = (error: AppError, children: React.ReactNode) => {
  const dispatch = useAppDispatch();

  const clearErrorHandler = () => {
    dispatch(clearError());
  };

  switch (error.displayType) {
    case 'notFound':
      return <NotFound />;
    case 'alert':
      return (
        <>
          {children}{' '}
          <Snackbar
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
            open
            autoHideDuration={4000}
            onClose={clearErrorHandler}>
            <div className="statusAlert-container">
              <Alert severity="error" onClose={clearErrorHandler}>
                <AlertTitle>{error.message}</AlertTitle>
              </Alert>
            </div>
          </Snackbar>
        </>
      );
    default:
      return 'other error display types not currently supported';
  }
};

const AppErrorRenderer: React.FC<AppErrorRendererPropType> = ({
  children
}: AppErrorRendererPropType): ReactElement => {
  const error = useAppSelector(state => state.app.currentError);
  return <>{error ? errorSwitch(error, children) : children}</>;
};

export default AppErrorRenderer;
